module.exports = {"330822001":"天马街道","330822002":"紫港街道","330822003":"金川街道","330822104":"白石镇","330822108":"招贤镇","330822109":"青石镇","330822111":"球川镇","330822115":"辉埠镇","330822116":"芳村镇","330822200":"何家乡","330822211":"同弓乡","330822213":"大桥头乡","330822219":"新昌乡","330822221":"东案乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330822.json
// module id = 1008
// module chunks = 0